import React from 'react';

type unit = 'month' | 'hour';

interface FormatPriceProps {
  priceAmount: number;
  unit: unit;
}

const FormatPrice: React.FC<FormatPriceProps> = (props) => (
  <span>{`$${(props.priceAmount / 100).toLocaleString()}/${props.unit}`}</span>
);

export default FormatPrice;
